import React, { useRef } from 'react';
import VideoJS from './VideoJS';

const Video = ({ videoPath, posterPath, videoCaptions = [], autoplay }) => {
  const playerRef = useRef(null);

  const videoJsOptions = {
    autoplay,
    controls: true,
    responsive: true,
    fluid: true,
    poster: posterPath,
    controlBar: autoplay
      ? {
          playToggle: false,
          progressControl: false,
        }
      : {},
    userActions: autoplay
      ? {
          hotkeys: false,
          doubleClick: false,
        }
      : {},
    sources: [
      {
        src: videoPath,
        type: 'video/mp4',
      },
    ],
  };

  const handlePlayerReady = (player) => {
    videoCaptions.forEach((vc) => {
      const track = {
        kind: 'captions',
        srclang: vc.srcLang,
        label: vc.label,
        src: vc.src,
      };
      player.addRemoteTextTrack(track, true);
    });

    // Disable click to play/pause
    if (autoplay) {
      player.tech_.el_.style.pointerEvents = 'none';
    }

    playerRef.current = player;
  };

  return (
    <>
      <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
    </>
  );
};

export default Video;
